import { useEffect, useState, useCallback } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useVerificaResultado = ({ sqAcaoFiscal }) => {
  const { request, data } = useApiClient();
  const [existe, setExiste] = useState("");

  const verificaResultado = useCallback(() => {
    if (sqAcaoFiscal) {
      request(apiRoutes.fiscalizacao.ocorrencia.verificaResultado, { sqAcaoFiscal });
    }
  }, [request, sqAcaoFiscal]);

  useEffect(() => {
    if (data) {
      setExiste(data?.result);
    }
  }, [data]);

  return { verificaResultado, existe };
};

export default useVerificaResultado;
